import { type MutationPayload } from 'vuex';
import Store from '../stores/store';
import { ClubsModuleConstant } from '../constants';
import type { ltFramework } from '@life-time-inc/enterprise-framework-core';

export default class ClubsStore implements ltFramework.IClubsStore {
	public getInitialData(): ltFramework.IClubsList {
		return (Store.state as ltFramework.IStoreState).clubsModule.clubsList;
	}

	public initialize(): Promise<void> {
		return Store.dispatch(ClubsModuleConstant.name + '/' + ClubsModuleConstant.action.initialize);
	}

	public listen(callback: (state: ltFramework.IClubsList) => void): () => void {
		return Store.subscribe((mutation: MutationPayload, state: ltFramework.IRootState) => {
			if (mutation.type.includes(ClubsModuleConstant.name + '/')) {
				callback((state as ltFramework.IStoreState).clubsModule.clubsList);
			}
		});
	}
}
